export default {
  API_ENDPOINT: process.env.REACT_APP_API_URL,
  MAPBOX_TOKEN: process.env.REACT_APP_API_TOKEN
};
